import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';

import './index.scss';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"
import { Provider } from 'react-redux';
import { store } from './store';
import setupAxios from "./middleware/setupaxios";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCG6QRuPmupeRT9RFZyksJdYOYz7SfjcWM",
  authDomain: "mosi-thunder.firebaseapp.com",
  projectId: "mosi-thunder",
  storageBucket: "mosi-thunder.firebasestorage.app",
  messagingSenderId: "635106819016",
  appId: "1:635106819016:web:9b38c0be21cc724b4d5efd",
  measurementId: "G-R7KG9052VG"
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);

setupAxios(store);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter >
        <App />
        <Toaster toastOptions={{
          error: {
            style: {
              background: '#de4936',
              color:'#fff'
            },
          },
        }} />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
